bq.global.runEllipsis = function ($delay) {
    var $delayNumber = $delay ? $delay : 2000;
		var dotdotdot = function() {
      $('.ellipsis').dotdotdot({
        watch: true,
        tolerance: 1,
        callback: afterCompleted
      });
    };

    setTimeout(function () {
      dotdotdot();
    }, $delayNumber);
};

function afterCompleted(isTruncated) {
	if (($(this).hasClass('onepage-item-title') || $(this).data('bq') === 'popup-original-title') && !isTruncated) {
		$(this).popover('destroy');
	}
}

bq.init.push(bq.global.runEllipsis);